let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g5ovv")).then(() => parcelRequire('k4eLp'));